import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
  GET_CMG_RESOLUTION_SUCCESS,
  GET_CMG_RESOLUTION_FAILURE,
  GET_CMG_RESOLUTION_LOADING,
} = therapyPlanningAction;

const intialState: object = {
  isError: false,
  errorMessage: '',
  response: null,
  loading: false,
};

export const getCmgResolutionReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case GET_CMG_RESOLUTION_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isError: false,
        errorMessage: '',
        loading: false,
      };
    }
    case GET_CMG_RESOLUTION_FAILURE: {
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };
    }
    case GET_CMG_RESOLUTION_LOADING: {
      return {
        ...intialState,
        loading: true,
      };
    }
    default:
      return state;
  }
};
